
	import Component from 'vue-class-component'
	import moduleStore from './store/extractResult';
	import Vue from 'vue';
	import PageState from './store/state';


	/**components**/
	@Component({})
	@moduleStore.initVuex({
		mutationNames:moduleStore.mutationNames,
		actionNames:moduleStore.actionNames
	})
	export default class extractResultPage extends Vue implements IvuePage<PageState>{
		state = new PageState();
		self:Vue = this;
		articleResult:any={}; 
		articleResultText:string = "" ;                    
		created(moduleData:IinjectDatas) {
			this.state = <PageState>moduleData.state;
		}
		mounted(moduleData:IinjectDatas){
			document.title="文案提取"
			// console.log('----this.$route',this.$route)
			// this.state.title="这是更改后的title"
			// this.state.self = this;
	
			// this.articleResult = JSON.parse(this.$route.query.params as string)
		
			// let  articleResultText = this.articleResult.text.trim();
			// this.articleResultText = articleResultText.startsWith("\n")?articleResultText.substring(1):articleResultText;
			// console.log('-----articleResult',this.articleResultText)
		}
	
	}